import { Comparer } from '@common/services';
import { createSelector } from '@ngrx/store';
import { DateTime } from 'luxon';

import { Entity } from '@apps/auth/domain/models/back';

import { IBackAuthEntitiesState } from '../entities.state';
import { entitiesAdapter } from '../entities.common';
import { getBackAuthEntitiesState } from '../entities.selectors';
import { BackAuthEntitiesExternalFeatureKey, IBackAuthEntitiesExternalState } from './entities-external.reducer';
import { filterQuickSearch } from '@common/services/utils.service';
import { BackConstants } from '@apps/back/back.constants';

export const getBackAuthEntitiesExternalState = createSelector(
    getBackAuthEntitiesState,
    (state: IBackAuthEntitiesState) =>
        state[BackAuthEntitiesExternalFeatureKey]
);

export const getEntitiesExternalCounters = createSelector(
    getBackAuthEntitiesExternalState,
    (state: IBackAuthEntitiesExternalState) =>
        state.counters
);

export const getEntitiesExternalQueryString = createSelector(
    getBackAuthEntitiesExternalState,
    (state: IBackAuthEntitiesExternalState) =>
        state.oData.qs
);
export const getBackAuthExternalEntitiesState = createSelector(
    getBackAuthEntitiesExternalState,
    (state: IBackAuthEntitiesExternalState) =>
        state.entities
);
export const {
    selectAll: getAllEntitiesExternal,
    selectTotal: getTotalExternalEntities,
} = entitiesAdapter.getSelectors(getBackAuthExternalEntitiesState);


const getQuickSearchedEntitiesExternal = createSelector(
    getBackAuthEntitiesExternalState,
    getAllEntitiesExternal,
    (state: IBackAuthEntitiesExternalState, entities: Entity[]) =>
        filterQuickSearch(entities, state.qsWord, BackConstants.entitiesQSFields)
);
export const getPipelinedEntitiesExternal = createSelector(
    getQuickSearchedEntitiesExternal,
    (entities: Entity[], params: { comparer: Comparer<Entity> }) =>
        [...entities].sort(params.comparer)
);
export const getEntitiesExternalActive = createSelector(
    getAllEntitiesExternal,
    (entities: Entity[]) =>
        entities.filter((entity: Entity) => entity.active)
);
export const getEntitiesExternalLoadingStatus = createSelector(
    getBackAuthEntitiesExternalState,
    (state: IBackAuthEntitiesExternalState) =>
        state.isLoading
);
export const getEntitiesExternalLoadedStatus = createSelector(
    getBackAuthEntitiesExternalState,
    (state: IBackAuthEntitiesExternalState) =>
        state.isLoaded
);
export const getEntitiesExternalOupsStatus = createSelector(
    getBackAuthEntitiesExternalState,
    (state: IBackAuthEntitiesExternalState) =>
        state.isOups
);
export const getEntitiesExternalEmptyStatus = createSelector(
    getBackAuthEntitiesExternalState,
    (state: IBackAuthEntitiesExternalState) =>
        state.isEmpty
);
export const getEntitiesExternalIsDataValid = createSelector(
    getBackAuthEntitiesExternalState,
    (state: IBackAuthEntitiesExternalState) =>
        state.expirationDate !== null && DateTime.utc() < state.expirationDate
);

const getQuickSearchedEntitiesExternalImpe = createSelector(
    getBackAuthEntitiesExternalState,
    getEntitiesExternalActive,
    (state: IBackAuthEntitiesExternalState, entities: Entity[]) =>
        filterQuickSearch(entities, state.qsWordImpe, BackConstants.entitiesQSFields)
);
export const getEntitiesExternalImpePipelined = createSelector(
    getQuickSearchedEntitiesExternalImpe,
    (entities: Entity[]) =>
        entities
    // (entities: Entity[], params: { comparer: Comparer<Entity> }) =>
    //     [...entities].sort(params.comparer)
);
